;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { cva } from 'class-variance-authority'

import { cn } from '../../utils/cn'

const dividerStyles = cva('bg-gray-300', {
  variants: {
    orientation: {
      vertical: 'inline-block h-full w-px',
      horizontal: 'block h-px w-full',
    },
  },
})

export function Separator({
  className,
  orientation,
}: {
  className?: string
  orientation: 'vertical' | 'horizontal'
}) {
  return (
    <span
      aria-hidden="true"
      className={cn(dividerStyles({ orientation }), className)}
    >
      &nbsp;
    </span>
  )
}
